import { refreshUser } from "./api.actions";

const checkStatus = (response, action) => (dispatch) => {
  // if (!response.ok) {
  //     throw Error(response.statusText);
  // }
  // return response;
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else if (response.status === 401) {
    return dispatch(refreshUser()).then((response) => {
      if (response && action) {
        return dispatch(action).then(({ response, error }) => {
          if (response) {
            return response;
          } else {
            return { response: error };
          }
        });
      } else {
        window.location.href = "/";
        // return Promise.reject(new Error('token_refreshing'));
      }
    });
  } else {
    return response.json().then((response) => {
      console.log("error", response);
      var error = new Error(response);
      error.response = response;
      return Promise.reject(error);
      // throw error;
    });
  }
};

export const callApi = (
  endpoint,
  authenticated,
  config = {},
  params,
  action
) => (dispatch) => {
  let token = sessionStorage.getItem("access_token") || null;
  let id_pos = sessionStorage.getItem("id_pos") || null;

  config = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    ...config,
  };

  if (authenticated) {
    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`,
        pos: id_pos,
        ...config.headers,
      };
    } else {
      throw new Error("No token or pos saved!");
    }
  }

  let url = new URL(endpoint);
  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return fetch(url, config)
    .then((response) => {
      return dispatch(checkStatus(response, action));
    })
    .then((response) => {
      if (response) {
        try {
          return response.json();
        } catch (e) {
          return Promise.reject(response);
        }
      } else {
        var error = new Error();
        error.response = {
          exception: "Token expired",
          errorCode: "401",
          message: "Token refreshing error. Please try again",
        };
        return Promise.reject(error); // OH JOLINES SE HA QUEDADO SIN COMODINES! NO BORRAR!
      }
    });
};

export const CALL_API = Symbol("Call API");

const api = ({ dispatch }) => (next) => (action) => {
  const callAPI = action[CALL_API];

  // So the middleware doesn't get applied to every single action
  if (typeof callAPI === "undefined") {
    return next(action);
  }

  let { endpoint, types, authenticated, config, params, ...rest } = callAPI;

  const [, successType, errorType] = types;

  return dispatch(
    callApi(endpoint, authenticated, config, params, action)
  ).then(
    (response) =>
      next({
        response,
        authenticated,
        type: successType,
        ...rest,
      }),
    (error) =>
      next({
        error: error.response,
        type: errorType,
      })
  );
};

export default api;
